import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

(function () {
    const swiper = document.querySelector('[data-swiper-testimonials]');

    if (swiper) {
        new Swiper(swiper, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            spaceBetween: 30,
            slidesPerView: 1,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        });
    }
})();
